/**
 * System API functions
 */
import { ENDPOINTS } from './endpoints';
import { getRequestBackendDataV2NoAuth } from './core';

export async function getVersionInfoV2NoAuth(callback) {
    // Get backend version
    await getRequestBackendDataV2NoAuth(callback, ENDPOINTS.SYSTEM.VERSION);
}

